module.exports = "/_next/static/files/8b08918a03d693f23b342bfcce933129.png";